export default __webpack_public_path__ + "static/media/icons-project-inspection.d56a3a04.svg";